export default __webpack_public_path__ + "static/media/essays.b2c7441a.webp";